(function() {
    const triggers = document.querySelectorAll('[data-lap-modal-content]');
    const modal = document.getElementById('lap-modal');
    const modalContent = document.getElementById('lap-modal__content');
    const closeBtn = modal?.querySelector('.js-lap-hero-modal-close');


    triggers.forEach(trigger => {
        const identifier = trigger.getAttribute('data-lap-modal-content');
        const content = document.getElementById(identifier);

        trigger.addEventListener('click', () =>
        {
            modalContent.innerHTML = content.innerHTML;
            modal.classList.remove('hidden');
            modal.classList.add('flex');
            document.body.style.overflow = 'hidden';
        });

    });

    const closeModal = () => {
        modal.classList.add('hidden');
        modal.classList.remove('flex');
        document.body.style.overflow = '';

        // Stop video playback by resetting iframe src or pausing video element
        const iframe = modal.querySelector('iframe');
        if (iframe) {
            const src = iframe.src;
            iframe.src = '';
            iframe.src = src.replace('?autoplay=1', '');
        }
        const video = modal.querySelector('video');
        if (video) {
            video.pause();
        }
    };

    closeBtn?.addEventListener('click', closeModal);
    modal.addEventListener('click', (e) => {
        if (e.target === modal) closeModal();
    });
})();